document.addEventListener('DOMContentLoaded', () => {

    // --- Scroll Animations (Intersection Observer) ---
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.fade-in, .fade-in-up, .fade-in-left, .fade-in-right');
    animatedElements.forEach(el => observer.observe(el));

    // --- Header Scroll Effect ---
    const header = document.getElementById('header');

    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        });
    }

    // --- Mobile Menu Toggle ---
    const mobileBtn = document.querySelector('.mobile-menu-btn');
    const mobileNav = document.querySelector('.nav');

    if (mobileBtn && mobileNav) {
        mobileBtn.addEventListener('click', () => {
            const isOpen = mobileNav.classList.toggle('mobile-open');
            mobileBtn.setAttribute('aria-expanded', isOpen);
        });
    }

    // --- Shopify Cart API Helpers ---
    async function fetchCart() {
        const res = await fetch('/cart.js');
        return await res.json();
    }

    async function addToCart(variantId, quantity) {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
        });
        return await res.json();
    }

    async function changeCartItem(line, quantity) {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: quantity })
        });
        return await res.json();
    }

    function updateCartCount(count) {
        document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = count;
        });
    }

    // --- Cart Drawer Logic ---
    const cartOverlay = document.createElement('div');
    cartOverlay.className = 'cart-overlay';
    const cartDrawer = document.createElement('div');
    cartDrawer.className = 'cart-drawer';

    cartDrawer.innerHTML = `
        <div class="cart-header">
            <span class="cart-title">Tu Carrito</span>
            <div class="cart-close">✕</div>
        </div>
        <div class="cart-items"></div>
        <div class="cart-footer">
            <div class="cart-total">
                <span>Subtotal</span>
                <span class="cart-total-price">$0.00</span>
            </div>
            <button class="btn-checkout">Proceder al Pago</button>
            <a href="/cart" class="btn-view-cart" style="display:block;text-align:center;padding:0.75rem;color:#64748b;font-size:0.85rem;text-decoration:none;margin-top:0.5rem;">Ver Carrito Completo →</a>
        </div>
    `;

    document.body.appendChild(cartOverlay);
    document.body.appendChild(cartDrawer);

    const cartItemsContainer = cartDrawer.querySelector('.cart-items');
    const cartTotalPrice = cartDrawer.querySelector('.cart-total-price');
    const checkoutBtn = cartDrawer.querySelector('.btn-checkout');

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
            window.location.href = '/checkout';
        });
    }

    function renderCart(cart) {
        if (!cart || !cart.items) return;
        updateCartCount(cart.item_count);

        if (cart.items.length === 0) {
            cartItemsContainer.innerHTML = '<p style="text-align:center;color:#999;padding:2rem;">Tu carrito está vacío</p>';
        } else {
            cartItemsContainer.innerHTML = cart.items.map((item, index) => `
                <div class="cart-item">
                    <img src="${item.image}" class="cart-item-img" alt="${item.title}">
                    <div class="cart-item-info">
                        <div class="cart-item-title">${item.title}</div>
                        <div class="cart-item-price">${Shopify.formatMoney ? Shopify.formatMoney(item.final_line_price) : ('$' + Math.round(item.final_line_price / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 }) + ' COP')}</div>
                        <div class="cart-item-remove" data-line="${index + 1}">Eliminar</div>
                    </div>
                </div>
            `).join('');
        }

        const totalFormatted = Shopify.formatMoney ? Shopify.formatMoney(cart.total_price) : ('$' + Math.round(cart.total_price / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 }) + ' COP');
        cartTotalPrice.textContent = totalFormatted;

        // Attach remove handlers
        cartDrawer.querySelectorAll('.cart-item-remove').forEach(btn => {
            btn.addEventListener('click', async (e) => {
                const line = parseInt(e.target.dataset.line);
                const updatedCart = await changeCartItem(line, 0);
                renderCart(updatedCart);
            });
        });
    }

    function toggleCart() {
        document.body.classList.toggle('cart-open');
        if (document.body.classList.contains('cart-open')) {
            fetchCart().then(renderCart);
        }
    }

    // Cart trigger buttons — header icon just toggles drawer
    document.querySelectorAll('.cart-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            toggleCart();
        });
    });

    // Add-to-cart buttons on product cards (have data-variant-id)
    document.addEventListener('click', async (e) => {
        const btn = e.target.closest('.product-card .cart-trigger');
        if (!btn) return;
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (variantId) {
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.5';
            await addToCart(parseInt(variantId), 1);
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
        }
        toggleCart();
    });

    // Close events
    const closeBtn = cartDrawer.querySelector('.cart-close');
    if (closeBtn) closeBtn.addEventListener('click', toggleCart);
    cartOverlay.addEventListener('click', toggleCart);

    // --- Add to Cart (Product Page) ---
    const addToCartForm = document.querySelector('form[action="/cart/add"]');
    if (addToCartForm) {
        addToCartForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const formData = new FormData(addToCartForm);
            const variantId = formData.get('id');
            const quantity = parseInt(formData.get('quantity')) || 1;

            await addToCart(variantId, quantity);
            toggleCart();
        });
    }

    // --- Quantity Selector ---
    document.querySelectorAll('.qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const input = btn.parentElement.querySelector('.qty-input');
            let val = parseInt(input.value) || 1;
            if (btn.textContent.trim() === '+') {
                val++;
            } else if (btn.textContent.trim() === '-' && val > 1) {
                val--;
            }
            input.value = val;
            // Update hidden quantity input if present
            const hiddenQty = document.querySelector('input[name="quantity"]');
            if (hiddenQty) hiddenQty.value = val;
        });
    });

    // --- Product Gallery: Thumbnail Click ---
    const mainImg = document.getElementById('main-product-image');
    const thumbs = document.querySelectorAll('.thumbnail');
    if (mainImg && thumbs.length) {
        thumbs.forEach(thumb => {
            thumb.addEventListener('click', () => {
                thumbs.forEach(t => t.classList.remove('active'));
                thumb.classList.add('active');
                mainImg.src = thumb.dataset.imageUrl;
                if (thumb.dataset.zoomUrl) {
                    mainImg.dataset.zoomSrc = thumb.dataset.zoomUrl;
                }
            });
        });
    }

    // --- Product Lightbox ---
    const lightbox = document.getElementById('product-lightbox');
    const lightboxImg = document.getElementById('lightbox-image');
    const lightboxCounter = document.getElementById('lightbox-counter');
    if (lightbox && mainImg) {
        let currentIndex = 0;
        const images = [];
        thumbs.forEach((thumb, i) => {
            images.push(thumb.dataset.zoomUrl || thumb.dataset.imageUrl);
        });
        // If no thumbnails, use main image
        if (images.length === 0 && mainImg.dataset.zoomSrc) {
            images.push(mainImg.dataset.zoomSrc);
        }

        function openLightbox(index) {
            if (!images.length) return;
            currentIndex = index;
            lightboxImg.src = images[currentIndex];
            if (lightboxCounter) {
                lightboxCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
            }
            lightbox.classList.add('lightbox-open');
            document.body.style.overflow = 'hidden';
        }

        function closeLightbox() {
            lightbox.classList.remove('lightbox-open');
            document.body.style.overflow = '';
        }

        // Open on main image click
        document.getElementById('product-main-image-wrapper').addEventListener('click', () => {
            // Find current active thumbnail index
            let idx = 0;
            thumbs.forEach((t, i) => { if (t.classList.contains('active')) idx = i; });
            openLightbox(idx);
        });

        // Close
        lightbox.querySelector('.lightbox-close').addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox || e.target.classList.contains('lightbox-content')) closeLightbox();
        });

        // Nav
        const prevBtn = lightbox.querySelector('.lightbox-prev');
        const nextBtn = lightbox.querySelector('.lightbox-next');
        if (prevBtn) prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            openLightbox((currentIndex - 1 + images.length) % images.length);
        });
        if (nextBtn) nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            openLightbox((currentIndex + 1) % images.length);
        });

        // Keyboard
        document.addEventListener('keydown', (e) => {
            if (!lightbox.classList.contains('lightbox-open')) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') openLightbox((currentIndex - 1 + images.length) % images.length);
            if (e.key === 'ArrowRight') openLightbox((currentIndex + 1) % images.length);
        });

        // Hide nav if only 1 image
        if (images.length <= 1) {
            if (prevBtn) prevBtn.style.display = 'none';
            if (nextBtn) nextBtn.style.display = 'none';
            if (lightboxCounter) lightboxCounter.style.display = 'none';
        }
    }

    // --- Cart Page Logic ---
    const cartPageItems = document.getElementById('cart-page-items');
    if (cartPageItems) {
        function formatMoney(cents) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
            const amount = Math.round(cents / 100);
            return '$' + amount.toLocaleString('es-CO', { maximumFractionDigits: 0 }) + ' COP';
        }

        async function updateCartPage() {
            const cart = await fetchCart();
            updateCartCount(cart.item_count);
            const subtotalEl = document.getElementById('cart-summary-subtotal');
            const totalEl = document.getElementById('cart-summary-total');
            const countEl = document.getElementById('cart-page-count');
            if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
            if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
            if (countEl) {
                countEl.textContent = cart.item_count === 0
                    ? 'Tu carrito está vacío'
                    : 'Tienes ' + cart.item_count + ' artículos en tu carrito';
            }
            if (cart.item_count === 0) {
                window.location.reload();
            }
            return cart;
        }

        // Quantity buttons
        cartPageItems.addEventListener('click', async (e) => {
            const plusBtn = e.target.closest('.cart-qty-plus');
            const minusBtn = e.target.closest('.cart-qty-minus');
            const removeBtn = e.target.closest('.cart-remove-btn');

            if (plusBtn || minusBtn) {
                const row = e.target.closest('.cart-page-item');
                const input = row.querySelector('.cart-qty-input');
                const line = parseInt(input.dataset.line);
                let qty = parseInt(input.value);

                if (plusBtn) qty++;
                if (minusBtn && qty > 1) qty--;
                if (minusBtn && qty <= 1) qty = 1;

                input.value = qty;
                row.classList.add('loading');

                const cart = await changeCartItem(line, qty);
                // Update line total
                if (cart.items && cart.items[line - 1]) {
                    const lineTotal = row.querySelector('.cart-item-line-total');
                    if (lineTotal) lineTotal.textContent = formatMoney(cart.items[line - 1].final_line_price);
                }
                row.classList.remove('loading');
                await updateCartPage();
            }

            if (removeBtn) {
                const row = removeBtn.closest('.cart-page-item');
                const line = parseInt(removeBtn.dataset.line);
                row.classList.add('loading');
                await changeCartItem(line, 0);
                row.style.transition = 'opacity 0.3s, transform 0.3s';
                row.style.opacity = '0';
                row.style.transform = 'translateX(-20px)';
                setTimeout(async () => {
                    await updateCartPage();
                }, 300);
            }
        });

        // Manual quantity input change
        cartPageItems.addEventListener('change', async (e) => {
            if (e.target.classList.contains('cart-qty-input')) {
                const row = e.target.closest('.cart-page-item');
                const line = parseInt(e.target.dataset.line);
                let qty = parseInt(e.target.value);
                if (isNaN(qty) || qty < 1) qty = 1;
                e.target.value = qty;

                row.classList.add('loading');
                const cart = await changeCartItem(line, qty);
                if (cart.items && cart.items[line - 1]) {
                    const lineTotal = row.querySelector('.cart-item-line-total');
                    if (lineTotal) lineTotal.textContent = formatMoney(cart.items[line - 1].final_line_price);
                }
                row.classList.remove('loading');
                await updateCartPage();
            }
        });
    }

    // --- Hero Parallax Effect (disabled) ---

    // --- Smooth Scroll for Anchor Links ---
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            if (targetId === '#') return;

            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth'
        });
    }

    // --- Highlight Active Category Filter Based on URL ---
    const categoryLinks = document.querySelectorAll('.filter-link');
    if (categoryLinks.length > 0) {
        const currentPath = window.location.pathname;
        categoryLinks.forEach(link => {
            const linkPath = new URL(link.href).pathname;
            // If the current path equals the link path, mark as active
            if (currentPath === linkPath) {
                link.classList.add('active');
            } else {
                link.classList.remove('active');
            }
        });
    }
});
    });

    // --- Add 'visible' class to hero content immediately ---
    setTimeout(() => {
        const heroContent = document.querySelector('.hero-content');
        if (heroContent) heroContent.classList.add('visible');
    }, 100);

    // --- Quick View Modal Logic ---
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'modal-overlay';
    modalOverlay.innerHTML = `
        <div class="modal-content">
            <div class="modal-close">✕</div>
            <div class="modal-image-container">
                <img src="" alt="Product" class="modal-img" width="400" height="400">
            </div>
            <div class="modal-details">
                <h2 class="modal-product-title">Product Title</h2>
                <div class="modal-product-price">$0.00</div>
                <p class="modal-product-desc">Description</p>
                <div class="modal-actions">
                    <button class="btn btn-primary cart-trigger-modal" data-variant-id="">Añadir al Carrito</button>
                    <a href="#" class="view-full-details">Ver Detalles Completos</a>
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(modalOverlay);

    const modalImg = modalOverlay.querySelector('.modal-img');
    const modalTitle = modalOverlay.querySelector('.modal-product-title');
    const modalPrice = modalOverlay.querySelector('.modal-product-price');
    const modalDesc = modalOverlay.querySelector('.modal-product-desc');
    const modalClose = modalOverlay.querySelector('.modal-close');
    const modalCartBtn = modalOverlay.querySelector('.cart-trigger-modal');
    const modalDetailsLink = modalOverlay.querySelector('.view-full-details');

    function openModal(data) {
        modalImg.src = data.img;
        modalTitle.textContent = data.title;
        modalPrice.textContent = data.price;
        modalDesc.textContent = data.desc;
        if (data.url) modalDetailsLink.href = data.url;
        if (data.variantId) modalCartBtn.dataset.variantId = data.variantId;
        document.body.classList.add('modal-open');
    }

    function closeModal() {
        document.body.classList.remove('modal-open');
    }

    // Event Delegation for Quick View Buttons
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.quick-view-btn');
        if (btn) {
            e.preventDefault();
            const data = {
                title: btn.dataset.title,
                price: btn.dataset.price,
                img: btn.dataset.img,
                desc: btn.dataset.desc,
                url: btn.dataset.url || '#',
                variantId: btn.dataset.variantId || ''
            };
            openModal(data);
        }
    });

    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) closeModal();
    });

    // Handle "Add to Cart" inside Modal
    if (modalCartBtn) {
        modalCartBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            const variantId = modalCartBtn.dataset.variantId;
            if (variantId) {
                await addToCart(parseInt(variantId), 1);
            }
            closeModal();
            setTimeout(toggleCart, 300);
        });
    }

    // --- Initial cart count load ---
    fetchCart().then(cart => {
        if (cart) updateCartCount(cart.item_count);
    }).catch(() => {});

    // --- Predictive Search ---
    const searchToggleBtns = document.querySelectorAll('.search-toggle-btn');
    const searchOverlay = document.getElementById('search-overlay');
    const searchInput = document.getElementById('predictive-search-input');
    const searchResults = document.getElementById('predictive-search-results');
    const searchCloseBtn = document.getElementById('search-close-btn');

    function openSearch() {
        document.body.classList.add('search-open');
        if (searchInput) {
            setTimeout(() => searchInput.focus(), 100);
        }
    }
    function closeSearch() {
        document.body.classList.remove('search-open');
        if (searchInput) searchInput.value = '';
        if (searchResults) searchResults.innerHTML = '';
    }

    searchToggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openSearch();
        });
    });

    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
    if (searchOverlay) {
        searchOverlay.addEventListener('click', (e) => {
            if (e.target === searchOverlay) closeSearch();
        });
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('search-open')) {
            closeSearch();
        }
    });

    // Filter toggle is handled by the inline script in section-collection.liquid
    // Do NOT add a duplicate listener here — it would toggle twice and cancel itself

    let searchDebounce;
    if (searchInput) {
        searchInput.addEventListener('input', () => {
            clearTimeout(searchDebounce);
            const query = searchInput.value.trim();
            if (query.length < 2) {
                if (searchResults) searchResults.innerHTML = '';
                return;
            }
            searchDebounce = setTimeout(async () => {
                try {
                    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
                    const data = await res.json();
                    const products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];

                    if (products.length === 0) {
                        searchResults.innerHTML = '<div class="search-results__empty">No se encontraron resultados para "' + query.replace(/</g, '&lt;') + '"</div>';
                        return;
                    }

                    let html = '<ul class="search-results__list">';
                    products.forEach(p => {
                        const imgSrc = p.image || '';
                        const price = p.price ? ('$' + (parseFloat(p.price)).toFixed(2)) : '';
                        html += `<li><a href="${p.url}" class="search-result-item">
                            ${imgSrc ? '<img src="' + imgSrc + '" alt="" class="search-result-item__img" width="56" height="56" loading="lazy">' : ''}
                            <div class="search-result-item__info">
                                <div class="search-result-item__title">${p.title}</div>
                                <div class="search-result-item__price">${price}</div>
                            </div>
                        </a></li>`;
                    });
                    html += '</ul>';
                    html += '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="search-results__view-all">Ver todos los resultados →</a>';
                    searchResults.innerHTML = html;
                } catch (err) {
                    searchResults.innerHTML = '';
                }
            }, 300);
        });
    }

    // --- AJAX Collection Filters (Category, Price, Availability) ---
    const collectionFiltersForm = document.querySelector('.collection-filters__form');
    const productsGrid = document.querySelector('.products-carousel');
    const productsCountDisplay = document.getElementById('products-count-display');
    const paginationWrapper = document.getElementById('pagination-wrapper');
    const collectionToolbar = document.querySelector('.collection-toolbar');
    
    if (collectionFiltersForm) {
        let isFiltering = false;

        // Function to update checkbox visual state
        function updateCheckboxState(checkbox) {
            const label = checkbox.closest('.filter-checkbox');
            if (label) {
                if (checkbox.checked) {
                    label.classList.add('is-checked');
                } else {
                    label.classList.remove('is-checked');
                }
            }
        }

        // Intercept category link clicks
        const categoryLinks = collectionFiltersForm.querySelectorAll('.filter-link');
        categoryLinks.forEach(link => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                if (isFiltering) return;
                
                const url = link.getAttribute('href');
                await applyFilters(url);
            });
        });

        // Intercept filter form submission (for price/availability)
        collectionFiltersForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            if (isFiltering) return;

            const formData = new FormData(collectionFiltersForm);
            const params = new URLSearchParams();
            
            // Get current URL (might have tag filter)
            const currentUrl = new URL(window.location.href);
            let baseUrl = currentUrl.pathname;
            
            // Add form parameters
            for (const [key, value] of formData.entries()) {
                if (value) params.append(key, value);
            }
            
            const filterUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
            await applyFilters(filterUrl);
        });

        // Intercept checkbox changes for instant filtering
        const filterCheckboxes = collectionFiltersForm.querySelectorAll('input[type="checkbox"]');
        filterCheckboxes.forEach(checkbox => {
            // Update visual state immediately
            updateCheckboxState(checkbox);
            
            checkbox.addEventListener('change', () => {
                updateCheckboxState(checkbox);
                if (!isFiltering) {
                    collectionFiltersForm.dispatchEvent(new Event('submit'));
                }
            });
        });

        async function applyFilters(url) {
            if (isFiltering) return;
            isFiltering = true;

            // Add loading state
            if (productsGrid) {
                productsGrid.classList.add('is-loading');
            }

            try {
                // Fetch the filtered page
                const response = await fetch(url);
                const html = await response.text();
                
                // Parse response
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Update products grid
                const newProductsGrid = doc.querySelector('.products-carousel');
                if (productsGrid && newProductsGrid) {
                    productsGrid.innerHTML = newProductsGrid.innerHTML;
                }
                
                // Update product count
                const newCountDisplay = doc.getElementById('products-count-display');
                if (productsCountDisplay && newCountDisplay) {
                    productsCountDisplay.innerHTML = newCountDisplay.innerHTML;
                }
                
                // Update pagination
                const newPagination = doc.getElementById('pagination-wrapper');
                if (paginationWrapper && newPagination) {
                    paginationWrapper.innerHTML = newPagination.innerHTML;
                    // Re-attach pagination click handlers
                    attachPaginationHandlers();
                } else if (paginationWrapper && !newPagination) {
                    paginationWrapper.innerHTML = '';
                }
                
                // Update active filters display
                const activeFiltersContainer = document.querySelector('.active-filters');
                const newActiveFilters = doc.querySelector('.active-filters');
                if (activeFiltersContainer && newActiveFilters) {
                    activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
                } else if (activeFiltersContainer && !newActiveFilters) {
                    activeFiltersContainer.remove();
                } else if (!activeFiltersContainer && newActiveFilters) {
                    collectionToolbar.insertAdjacentHTML('afterend', newActiveFilters.outerHTML);
                }
                
                // Update filter sidebar (for updated counts)
                const newFiltersForm = doc.querySelector('.collection-filters__form');
                if (collectionFiltersForm && newFiltersForm) {
                    // Save current scroll position of filters
                    const filtersContainer = collectionFiltersForm.closest('.collection-filters');
                    const scrollTop = filtersContainer ? filtersContainer.scrollTop : 0;
                    
                    collectionFiltersForm.innerHTML = newFiltersForm.innerHTML;
                    
                    // Restore scroll position
                    if (filtersContainer) {
                        filtersContainer.scrollTop = scrollTop;
                    }
                    
                    // Re-attach all event listeners
                    attachFilterHandlers();
                }
                
                // Update browser URL without reload
                window.history.pushState({}, '', url);
                
                // Scroll to top of products (smooth)
                if (productsGrid) {
                    productsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                
            } catch (error) {
                console.error('Filter error:', error);
            } finally {
                if (productsGrid) {
                    productsGrid.classList.remove('is-loading');
                }
                isFiltering = false;
            }
        }

        function attachFilterHandlers() {
            // Re-attach category links
            const categoryLinks = collectionFiltersForm.querySelectorAll('.filter-link');
            categoryLinks.forEach(link => {
                link.addEventListener('click', async (e) => {
                    e.preventDefault();
                    if (isFiltering) return;
                    const url = link.getAttribute('href');
                    await applyFilters(url);
                });
            });

            // Re-attach form submit
            collectionFiltersForm.removeEventListener('submit', handleFormSubmit);
            collectionFiltersForm.addEventListener('submit', handleFormSubmit);

            // Re-attach checkboxes
            const filterCheckboxes = collectionFiltersForm.querySelectorAll('input[type="checkbox"]');
            filterCheckboxes.forEach(checkbox => {
                // Update visual state immediately
                updateCheckboxState(checkbox);
                
                checkbox.addEventListener('change', () => {
                    updateCheckboxState(checkbox);
                    if (!isFiltering) {
                        collectionFiltersForm.dispatchEvent(new Event('submit'));
                    }
                });
            });
        }

        async function handleFormSubmit(e) {
            e.preventDefault();
            if (isFiltering) return;

            const formData = new FormData(collectionFiltersForm);
            const params = new URLSearchParams();
            
            const currentUrl = new URL(window.location.href);
            let baseUrl = currentUrl.pathname;
            
            for (const [key, value] of formData.entries()) {
                if (value) params.append(key, value);
            }
            
            const filterUrl = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
            await applyFilters(filterUrl);
        }

        function attachPaginationHandlers() {
            const paginationLinks = document.querySelectorAll('.pagination a');
            paginationLinks.forEach(link => {
                link.addEventListener('click', async (e) => {
                    e.preventDefault();
                    if (isFiltering) return;
                    const url = link.getAttribute('href');
                    await applyFilters(url);
                });
            });
        }

        // Attach initial pagination handlers
        attachPaginationHandlers();
    }

    // --- Handle Sort Select (AJAX) ---
    const sortSelect = document.getElementById('sort-select');
    if (sortSelect) {
        sortSelect.addEventListener('change', async (e) => {
            const selectedUrl = e.target.value;
            if (selectedUrl && collectionFiltersForm) {
                // Get current filters
                const currentUrl = new URL(window.location.href);
                const newUrl = new URL(selectedUrl, window.location.origin);
                
                // Preserve current filters
                currentUrl.searchParams.forEach((value, key) => {
                    if (!newUrl.searchParams.has(key)) {
                        newUrl.searchParams.set(key, value);
                    }
                });
                
                // Apply with AJAX
                const applyFilters = window.applyCollectionFilters || (async (url) => {
                    window.location.href = url;
                });
                await applyFilters(newUrl.toString());
            } else {
                window.location.href = selectedUrl;
            }
        });
    }

});
